ReportSubscriptionListController.$inject = ["dateRangeTypes", "reportSubscriptionPeriods", "$translate"];
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/* injects from baggage-loader */
require('./report-subscription-list.component.html');
import angular from 'angular';
import { ReportSpecsList } from '../../constants/reports/report-specifications';
import _ from 'lodash';
angular.module('AaApp.Opp').component('reportSubscriptionList', {
  templateUrl: '/app/components/reports/report-subscription-list.component.html',
  controller: ReportSubscriptionListController,
  bindings: {
    subscriptions: '<',
    onSubscriptionToggle: '&',
    onSubscriptionEdit: '&',
    onSubscriptionDelete: '&'
  }
});

/* @ngInject */
function ReportSubscriptionListController(dateRangeTypes, reportSubscriptionPeriods, $translate) {
  var $ctrl = this;
  $ctrl.dateRangeTypes;
  $ctrl.subscriptionPeriodTranslateKeys;
  $ctrl.$onChanges = onChanges;
  $ctrl.$onInit = init;
  $ctrl.translateCodes = [];
  function init() {
    $ctrl.dateRangeTranslateKeys = _.invert(dateRangeTypes);
    $ctrl.subscriptionPeriodTranslateKeys = _.invert(reportSubscriptionPeriods);
    var _iterator = _createForOfIteratorHelper($ctrl.subscriptions),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var subscription = _step.value;
        if (subscription.code == dateRangeTypes.day) subscription.translateCode = dateRangeTypes.previousDay;else subscription.translateCode = subscription.code;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  function onChanges(changes) {
    if (changes.subscriptions && changes.subscriptions.currentValue) {
      for (var i = 0; i < $ctrl.subscriptions.length; i++) {
        var subscription = $ctrl.subscriptions[i];
        //replace "Enterprise" to quickly and easily use the associated non-enterprise report version titleKey.
        var report = _.find(ReportSpecsList, function (item) {
          return item.id.toLowerCase() == subscription.reportId;
        });
        if (!report) continue;
        subscription.translateKey = report.titleKey.replace("Enterprise", "");
        subscription.hideDateRange = report.hideDateRange;
      }
    }
  }
}